import { getDropdownItemsFromStatusConfig } from 'shared/ui/Status'
import config from './config'

export const campaignStatusesDropdownItems = getDropdownItemsFromStatusConfig(config)
